import { Link, Navigate } from "react-router-dom";
import { ShieldCheck, UserPlus, LogIn } from "lucide-react";
import { Brand } from "@/components/Brand";
import { InstallAppButton } from "@/components/InstallAppButton";
import { SquaresArt } from "@/components/SquaresArt";
import { useAuth } from "@/context/AuthContext";

export default function Landing() {
  const { user } = useAuth();
  if (user) return <Navigate to="/painel" replace />;

  return (
    <div data-testid="landing-page" className="min-h-screen cofre-bg">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-10 sm:py-16 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20">
        <div className="fade-up">
          <Brand size="lg" />
          <h1 data-testid="landing-headline" className="mt-10 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-emerald-950">
            Guarde dinheiro <span className="text-amber-700">meta por meta</span>, quadradinho por quadradinho.
          </h1>
          <p data-testid="landing-tagline" className="mt-6 max-w-lg text-lg sm:text-xl text-slate-700 leading-relaxed">
            O cofrinho de papel que você já conhece, agora no celular. Simples, organizado e motivador.
          </p>
          <div className="mt-10 flex max-w-md flex-col gap-4">
            <Link
              to="/cadastro"
              data-testid="landing-create-account-button"
              className="flex min-h-[64px] items-center justify-center gap-3 rounded-2xl bg-emerald-700 px-6 font-heading text-xl font-bold text-white shadow-[0_6px_0_0_#064e3b] transition-[transform,box-shadow,background-color] duration-150 hover:bg-emerald-800 active:translate-y-[4px] active:shadow-[0_2px_0_0_#064e3b]"
            >
              <UserPlus className="h-6 w-6" /> Criar minha conta
            </Link>
            <Link
              to="/entrar"
              data-testid="landing-login-button"
              className="flex min-h-[64px] items-center justify-center gap-3 rounded-2xl border-2 border-emerald-700 bg-white px-6 font-heading text-xl font-bold text-emerald-800 transition-colors hover:bg-emerald-50"
            >
              <LogIn className="h-6 w-6" /> Entrar
            </Link>
            <Link
              to="/adm/login"
              data-testid="landing-admin-login-button"
              className="flex min-h-[52px] items-center justify-center gap-3 rounded-xl border-2 border-amber-300 bg-amber-50 px-6 text-lg font-bold text-amber-950 transition-colors hover:bg-amber-100"
            >
              <ShieldCheck className="h-5 w-5" />
              Acesso ADM
            </Link>
            <InstallAppButton />
          </div>
          <p className="mt-8 inline-flex items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-4 py-2 text-base font-semibold text-amber-900">
            <ShieldCheck className="h-5 w-5" /> Seus dados ficam só com você
          </p>
        </div>
        <div className="mx-auto w-full max-w-sm lg:max-w-md">
          <SquaresArt />
        </div>
      </div>
    </div>
  );
}
